<script>
import BlockingContainer from '@components/BlockingContainer';

export default {
  components: {
    BlockingContainer,
  },
  created() {
    document.body.style.backgroundColor = 'black';
  },
  destroyed() {
    // Reset background color when leaving login layout
    document.body.style.backgroundColor = '';
  },
  beforeDestroy() {
    // Also reset on beforeDestroy for safety
    document.body.style.backgroundColor = '';
  },
};

</script>

<template>
  <div>
    <b-container class="pt-4 mt-8 mb-4" style="margin-top: 10%;">
      <b-row>
        <b-col>
          <div class="d-flex align-items-center justify-content-center">
            <div class="d-flex flex-column align-items-end">
              <img src="@assets/images/logo_kks.png" class="d-inline-block align-top mb-4" alt="KKS" height="100px" />
            </div>
          </div>
          <BlockingContainer v-if="$wait.is('global loading')" />
          <slot />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';
</style>
